<template>
  <div class="cell small-12 large-auto">
    <Skeleton height="70px" width="450px" />
    <Skeleton class="margin-top-m" height="80px" />
    <div class="margin-bottom-m"></div>
    <div class="grid-x">
      <div class="cell small-12 medium-7 margin-top-s">
        <Skeleton height="200px" />
      </div>
      <div class="cell small-12 medium-1 margin-top-s"></div>
      <div class="cell small-12 medium-4 margin-top-s">
        <Skeleton height="200px" />
      </div>
    </div>
    <div class="margin-bottom-l margin-top-l"></div>
    <Skeleton height="80px" width="300px" />
    <div class="margin-bottom-m"></div>
    <Skeleton height="200px" />
    <div class="margin-bottom-l margin-top-l"></div>
    <div class="grid-x">
      <div class="cell small-12 medium-4 margin-top-s">
        <Skeleton height="200px" />
      </div>
      <div class="cell small-12 medium-1 margin-top-s"></div>
      <div class="cell small-12 medium-4 margin-top-s">
        <Skeleton height="200px" />
      </div>
    </div>
  </div>
  <Skeleton class="hide-for-small show-for-large large-offset-1" height="auto" width="110px" />
</template>
<script setup>
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton.vue';
</script>
